export const AUTH_EMAIL_KEY = "baytbuddy_user_email";

export function getStoredUserEmail() {
  return localStorage.getItem(AUTH_EMAIL_KEY) || "";
}

export function setStoredUserEmail(email) {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  if (!normalizedEmail) return;
  localStorage.setItem(AUTH_EMAIL_KEY, normalizedEmail);
}

export function removeStoredUserEmail() {
  localStorage.removeItem(AUTH_EMAIL_KEY);
}

export function clearAuthSession() {
  removeStoredUserEmail();

  // clean old legacy keys if they still exist
  localStorage.removeItem("baytbuddy_access_token");
  localStorage.removeItem("baytbuddy_user");
}

export function hasActiveSession() {
  return Boolean(getStoredUserEmail());
}

// backward compatibility only
export function getStoredUser() {
  return null;
}

export function setStoredUser() {
  return;
}

export function isProfileComplete() {
  return false;
}

export function isProfileIncomplete() {
  return true;
}